import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LoadingContext } from '../../contexts';
import DefaultSection, {DefaultSubSectionTitle, HorizontalRule} from '../../components/default_section/default_section';
import DefaultInput from '../../components/default_input/default_input';
import WarningMessage from '../../components/warning_message/warning_message';
import ModelTable, { Property } from '../../components/model_table/model_table';
import ContextPopup from '../../components/context_popup/context_popup';
import './complaint_type_data.scss';

class ComplaintTypeData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popupContent: null,
      popupTarget: null,
      screenWidth: window.innerWidth
    };
  }

  async componentDidMount() {
    this.resizeListener = () => this.updateSize();

    window.addEventListener("resize", this.resizeListener);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeListener);
  }

  updateSize() {
    this.setState({
      screenWidth: window.innerWidth
    });
  }

  handleKeyDown(event) {    
    if(event.keyCode === 13 && this.props.enableSave && !this.props.isLoading) {
      this.props.onSave();
    }
  }

  isHighlighted(propertyName) {
    return this.props.highlights.includes(propertyName);
  }

  getDocumentAssociationScoreInput(entry, property) {
    return (
      <DefaultInput
        className="complaint-type-data__document-association-configuration__input"
        name={`document_configurations:${entry.document_id}:${property}`}
        type="number"
        step="0.1"
        handleInputChange={this.props.handleInputChange}
        value={entry[property]}
        autoComplete="off"
        onFocus={(event) => event.target.select()}
        disabled={!entry.is_relevant || this.props.isLoading}
      />
    );
  }

  getDocumentAssociationIsRelevantInput(entry) {
    return (
      <div className='complaint-type-data__document-association-configuration__is-relevant-input-container'>

        <button
          className={`complaint-type-data__document-association-configuration__is-relevant-input${entry.is_relevant ? '--checked' : ''}`}
          onClick={() => this.props.onToggleIsRelevant(entry.document_id)}
          disabled={this.props.isLoading}
        >

          {entry.is_relevant &&
            <i className="fas fa-check"></i>
          }

        </button>

      </div>
    );
  }

  getDocumentAssociationProperties() {
    let properties = [
      Property('document_name', 'Documento', <i className="fa-solid fa-file"></i>),
      Property('score_when_absent', 'Pontuação se NÃO', <i className="fa-solid fa-square-xmark"></i>, {
        getDataText: (entry) => this.getDocumentAssociationScoreInput(entry, 'score_when_absent'),
        getSortCallback: (a, b) => {
          if (a.score_when_absent === b.score_when_absent) {
            return a.document_name.localeCompare(b.document_name);
          }

          return a.score_when_absent - b.score_when_absent;
        },
        cellClassName: "complaint-type-data__document-association-configuration__input-cell"
      }),
      Property('score_when_present', 'Pontuação se SIM', <i className="fa-solid fa-square-check"></i>, {
        getDataText: (entry) => this.getDocumentAssociationScoreInput(entry, 'score_when_present'),
        getSortCallback: (a, b) => {
          if (a.score_when_present === b.score_when_present) {
            return a.document_name.localeCompare(b.document_name);
          }

          return a.score_when_present - b.score_when_present;
        },
        cellClassName: "complaint-type-data__document-association-configuration__input-cell"
      }),
      Property('is_relevant', 'É relevante', null, {
        getDataText: (entry) => this.getDocumentAssociationIsRelevantInput(entry),
        getFilterText: (entry) => entry.is_relevant ? 'Sim' : 'Não',
        sortable: false,
        cellClassName: "complaint-type-data__document-association-configuration__input-cell"
      })
    ];

    return properties;
  }

  getDocumentAssociationInputs() {
    return (
      <div className="complaint-type-data__document-association-configuration">

        <ModelTable
          properties={this.getDocumentAssociationProperties()}
          data={this.props.complaint_type.document_configurations}
          initialLinesPerPage={this.props.complaint_type.document_configurations.length}
          initialOrderBy="document_name"
          hideFilter={true}
          hideLinesPerPageControl={true}
          hideNavigationControls={true}
          getIdCallback={(entry) => entry.document_id}
        >

        </ModelTable>

      </div>
    );
  }

  onShowHoverdata(target, text) {
    this.setState({
      popupContent: text,
      popupTarget: target,
    });
  }

  onHideHoverdata() {
    this.setState({
      popupContent: null,
      popupTarget: null,
    });
  }

  getRiscRangePosition(percentage) {
    const value = this.props.riskRange[0] + (percentage * (this.props.riskRange[1] - this.props.riskRange[0]) / 100);

    return value.toFixed(1);
  }

  render() {
    return (
      <>

        <ContextPopup
          targetElement={this.state.popupTarget}
          content={this.state.popupContent}
        />

        <DefaultSection
          className="complaint-type-data"
          title="Dados da queixa"
        >

          <div className="complaint-type-data__warning-container">

            <WarningMessage
              message={this.props.warningMessage}
              onClose={this.props.onCloseWarning}
              visible={this.props.showWarningMessage}
            />

          </div>

          <div className="complaint-type-data__input-container">

            <DefaultInput
              name="name"
              isHighlighted={this.isHighlighted("name")}
              label="Nome"
              type="text"
              placeholder="Nome da queixa"
              maxLength="128"
              handleInputChange={this.props.handleInputChange}
              value={this.props.complaint_type.name}
              autoComplete="off"
              onKeyDown={(event) => this.handleKeyDown(event)}
              disabled={this.props.isLoading}
            />
            
            <DefaultInput
              name="description"
              isHighlighted={this.isHighlighted("description")}
              label="Descrição"
              type="textarea"
              placeholder="Descrição da queixa"
              rows="4"
              handleInputChange={this.props.handleInputChange}
              value={this.props.complaint_type.description || ''}
              disabled={this.props.isLoading}
            />

            <HorizontalRule />

            <DefaultSubSectionTitle
              icon={<i className="fa-solid fa-file"></i>}
              text="Pontuação por documento"
            />

            {this.getDocumentAssociationInputs()}

            <HorizontalRule />

            <DefaultSubSectionTitle
              icon={<i className="fa-solid fa-triangle-exclamation"></i>}
              text="Faixas de risco"
            />

            <ul className="complaint-type-data__risk-range__list">

              <li className="complaint-type-data__risk-range--very-critical">

                <h4 className="complaint-type-data__risk-range__label">Muito crítico:</h4>

                <p className="complaint-type-data__risk-range__text">
                
                  {this.state.screenWidth >= 590 ? 'Maior ou igual a' : '≥'} <span className="complaint-type-data__risk-range__value">0%</span> {this.state.screenWidth >= 590 ? 'e menor que' : 'e <'} 
                  
                </p>

                <DefaultInput
                  className="complaint-type-data__risk-range__input"
                  name="critical_threshold"
                  type="number"
                  min="0.0"
                  max={this.props.complaint_type.moderate_threshold || '100.0'}
                  step="0.1"
                  handleInputChange={this.props.handleInputChange}
                  value={this.props.complaint_type.critical_threshold || ''}
                  autoComplete="off"
                  suffix="%"
                  onFocus={(event) => event.target.select()}
                  disabled={this.props.isLoading}
                />

                {(this.props.riskRange[0] !== null && typeof this.props.complaint_type.critical_threshold !== "string") &&
                  <i
                    className="fa-solid fa-circle-info complaint-type-data__risk-range__info-icon"
                    onMouseEnter={(event) => this.onShowHoverdata(event.target, (
                      <p className="complaint-type-data__risk-range__popup-text">
                        
                        [<span className="complaint-type-data__risk-range__popup-text--very-critical">{this.getRiscRangePosition(0)}</span>, <span className="complaint-type-data__risk-range__popup-text--very-critical">{this.getRiscRangePosition(this.props.complaint_type.critical_threshold)}</span>[
                        
                      </p>
                    ))}
                    onMouseLeave={(event) => this.onHideHoverdata()}
                  >
                  </i>
                }

              </li>

              <li className="complaint-type-data__risk-range--critical">

                <h4 className="complaint-type-data__risk-range__label">Crítico:</h4>

                <p className="complaint-type-data__risk-range__text">
                
                  {this.state.screenWidth >= 590 ? 'Maior ou igual a' : '≥'} <span className="complaint-type-data__risk-range__value">{this.props.complaint_type.critical_threshold || '-'}%</span> {this.state.screenWidth >= 590 ? 'e menor que' : 'e <'}  
                  
                </p>

                <DefaultInput
                  className="complaint-type-data__risk-range__input"
                  name="moderate_threshold"
                  type="number"
                  min={this.props.complaint_type.critical_threshold || '0.0'}
                  max={this.props.complaint_type.light_threshold || '100.0'}
                  step="0.1"
                  handleInputChange={this.props.handleInputChange}
                  value={this.props.complaint_type.moderate_threshold || ''}
                  autoComplete="off"
                  suffix="%"
                  onFocus={(event) => event.target.select()}
                  disabled={this.props.isLoading}
                />

                {(this.props.riskRange[0] !== null && typeof this.props.complaint_type.critical_threshold !== "string" && typeof this.props.complaint_type.moderate_threshold !== "string") &&
                  <i
                    className="fa-solid fa-circle-info complaint-type-data__risk-range__info-icon"
                    onMouseEnter={(event) => this.onShowHoverdata(event.target, (
                      <p className="complaint-type-data__risk-range__popup-text">
                        
                        [<span className="complaint-type-data__risk-range__popup-text--very-critical">{this.getRiscRangePosition(this.props.complaint_type.critical_threshold)}</span>, <span className="complaint-type-data__risk-range__popup-text--very-critical">{this.getRiscRangePosition(this.props.complaint_type.moderate_threshold)}</span>[
                        
                      </p>
                    ))}
                    onMouseLeave={(event) => this.onHideHoverdata()}
                  >
                  </i>
                }

              </li>

              <li className="complaint-type-data__risk-range--moderate">

                <h4 className="complaint-type-data__risk-range__label">Moderado:</h4>

                <p className="complaint-type-data__risk-range__text">
                
                  {this.state.screenWidth >= 590 ? 'Maior ou igual a' : '≥'} <span className="complaint-type-data__risk-range__value">{this.props.complaint_type.moderate_threshold || '-'}%</span> {this.state.screenWidth >= 590 ? 'e menor que' : 'e <'}  
                  
                </p>

                <DefaultInput
                  className="complaint-type-data__risk-range__input"
                  name="light_threshold"
                  type="number"
                  min={this.props.complaint_type.moderate_threshold || '0.0'}
                  max={this.props.complaint_type.very_light_threshold || '100.0'}
                  step="0.1"
                  handleInputChange={this.props.handleInputChange}
                  value={this.props.complaint_type.light_threshold || ''}
                  autoComplete="off"
                  suffix="%"
                  onFocus={(event) => event.target.select()}
                  disabled={this.props.isLoading}
                />

                {(this.props.riskRange[0] !== null && typeof this.props.complaint_type.moderate_threshold !== "string" && typeof this.props.complaint_type.light_threshold !== "string") &&
                  <i
                    className="fa-solid fa-circle-info complaint-type-data__risk-range__info-icon"
                    onMouseEnter={(event) => this.onShowHoverdata(event.target, (
                      <p className="complaint-type-data__risk-range__popup-text">
                        
                        [<span className="complaint-type-data__risk-range__popup-text--very-critical">{this.getRiscRangePosition(this.props.complaint_type.moderate_threshold)}</span>, <span className="complaint-type-data__risk-range__popup-text--very-critical">{this.getRiscRangePosition(this.props.complaint_type.light_threshold)}</span>[
                        
                      </p>
                    ))}
                    onMouseLeave={(event) => this.onHideHoverdata()}
                  >
                  </i>
                }

              </li>

              <li className="complaint-type-data__risk-range--light">

                <h4 className="complaint-type-data__risk-range__label">Leve:</h4>

                <p className="complaint-type-data__risk-range__text">
                
                  {this.state.screenWidth >= 590 ? 'Maior ou igual a' : '≥'} <span className="complaint-type-data__risk-range__value">{this.props.complaint_type.light_threshold || '-'}%</span> {this.state.screenWidth >= 590 ? 'e menor que' : 'e <'}  
                  
                </p>

                <DefaultInput
                  className="complaint-type-data__risk-range__input"
                  name="very_light_threshold"
                  type="number"
                  min={this.props.complaint_type.light_threshold || '0.0'}
                  max="100.0"
                  step="0.1"
                  handleInputChange={this.props.handleInputChange}
                  value={this.props.complaint_type.very_light_threshold || ''}
                  autoComplete="off"
                  suffix="%"
                  onFocus={(event) => event.target.select()}
                  disabled={this.props.isLoading}
                />

                {(this.props.riskRange[0] !== null && typeof this.props.complaint_type.light_threshold !== "string" && typeof this.props.complaint_type.very_light_threshold !== "string") &&
                  <i
                    className="fa-solid fa-circle-info complaint-type-data__risk-range__info-icon"
                    onMouseEnter={(event) => this.onShowHoverdata(event.target, (
                      <p className="complaint-type-data__risk-range__popup-text">
                        
                        [<span className="complaint-type-data__risk-range__popup-text--very-critical">{this.getRiscRangePosition(this.props.complaint_type.light_threshold)}</span>, <span className="complaint-type-data__risk-range__popup-text--very-critical">{this.getRiscRangePosition(this.props.complaint_type.very_light_threshold)}</span>[
                        
                      </p>
                    ))}
                    onMouseLeave={(event) => this.onHideHoverdata()}
                  >
                  </i>
                }

              </li>

              <li className="complaint-type-data__risk-range--very-light">

                <h4 className="complaint-type-data__risk-range__label">Muito leve:</h4>

                <p className="complaint-type-data__risk-range__text">
                
                  {this.state.screenWidth >= 590 ? 'Maior ou igual a' : '≥'} <span className="complaint-type-data__risk-range__value">{this.props.complaint_type.very_light_threshold || '-'}%</span> {this.state.screenWidth >= 590 ? 'e menor ou igual que' : 'e ≤'} <span className="complaint-type-data__risk-range__value">100%</span>
                  
                </p>

                {(this.props.riskRange[0] !== null && typeof this.props.complaint_type.very_light_threshold !== "string") &&
                  <i
                    className="fa-solid fa-circle-info complaint-type-data__risk-range__info-icon"
                    onMouseEnter={(event) => this.onShowHoverdata(event.target, (
                      <p className="complaint-type-data__risk-range__popup-text">
                        
                        [<span className="complaint-type-data__risk-range__popup-text--very-critical">{this.getRiscRangePosition(this.props.complaint_type.very_light_threshold)}</span>, <span className="complaint-type-data__risk-range__popup-text--very-critical">{this.getRiscRangePosition(100)}</span>]
                        
                      </p>
                    ))}
                    onMouseLeave={(event) => this.onHideHoverdata()}
                  >
                  </i>
                }

              </li>

            </ul>

          </div>

          <HorizontalRule />

          <div className="complaint-type-data__buttons-container">

            <button
              className="complaint-type-data__save-button"
              disabled={!this.props.enableSave || this.props.isLoading}
              onClick={this.props.onSave}
            >

              Salvar

            </button>

            <Link
              className="complaint-type-data__cancel-button"
              to={this.props.onCancelPath}
              disabled={this.props.isLoading}
            >

              Cancelar

            </Link>

          </div>

        </DefaultSection>

      </>
    );
  }
};

const WrappedComplaintTypeData = props => {
  const {isLoading} = useContext(LoadingContext);

  return (
    <ComplaintTypeData
      isLoading={isLoading}
      {...props}
    />
  );
};

export {WrappedComplaintTypeData as ComplaintTypeData};
